import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { useLocalStorage } from './useLocalStorage';

export const useVariableWidthContainers = (name: string) => {
  const [width, setWidth] = useLocalStorage(`${name}-proportion`, 0.7);
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const onScalerMouseDown = (evt: SyntheticEvent) => {
    evt.preventDefault();
    evt.stopPropagation();
    setIsDragging(true);
    return false;
  };

  const handleMouseUp = (evt: MouseEvent) => {
    evt.preventDefault();
    evt.stopPropagation();
    setIsDragging(false);
    return false;
  };

  const handleMouseMove = (evt: MouseEvent) => {
    if (isDragging && containerRef.current) {
      const containerRect = containerRef.current.getBoundingClientRect();
      const newWidth = (evt.clientX - containerRect.left) / containerRect.width;
      setWidth(newWidth);
    }
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
    } else {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  return {
    width,
    containerRef,
    onScalerMouseDown,
    leftStyle: { flex: width, maxWidth: '100%', position: 'relative' },
    rightStyle: { flex: 1 - width },
  };
};
